import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './news-primary.scss';

export class TagsList extends PureComponent {
  render() {
    return (
      <ul className="tags-list">
        {this.props.tags.map(tag =>
          <li key={tag.id}>
            {(!this.props.canNavigate) &&
              <button className="tag-button" type="button">
                {tag.name}
              </button>
            }

            {(this.props.canNavigate) &&
              <Link
                className="tag-button"
                to={`${this.props.pathname}?list&tags=${tag.id}`}
              >
                {tag.name}
              </Link>
            }
          </li>
        )}
      </ul>
    );
  }
}

TagsList.propTypes = {
  canNavigate: PropTypes.bool,
  tags: PropTypes.arrayOf(PropTypes.object),
  pathname: PropTypes.string
};

class NewsPrimary extends PureComponent {
  render() {
    return (
      <Link
        className="news-primary"
        to={`${this.props.pathname}${this.props.content.id}/`}
      >
        <div className="news-primary-container">
          {(!!this.props.content.previewImage) &&
            <div
              className="news-primary-image"
              style={{ backgroundImage: `url(${this.props.content.previewImage})` }}
            />
          }

          <div className="news-primary-content">
            <span
              className="news-primary-date"
              dangerouslySetInnerHTML={{ __html: this.props.content.dateDisplay }}
            />

            <h2 dangerouslySetInnerHTML={{ __html: this.props.content.title }} />

            <p dangerouslySetInnerHTML={{ __html: this.props.content.previewText }} />

            <div className="news-primary-links">
              {(!!this.props.content.tags) &&
                <TagsList tags={this.props.content.tags}/>
              }

              <div className="btn btn-arrowed">
                Подробнее <span className="icon">→</span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

NewsPrimary.propTypes = {
  pathname: PropTypes.string.isRequired,
  content: PropTypes.shape({
    id: PropTypes.number,
    previewImage: PropTypes.string,
    dateDisplay: PropTypes.string,
    title: PropTypes.string,
    previewText: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.object)
  })
};

export default NewsPrimary;



// WEBPACK FOOTER //
// ./src/components/News/NewsPrimary.js